import styled from "styled-components/macro";
import arrow from './arrow_up.svg'; 


export const DropdownContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
.Dropdown-root {
    width: 340px; 
    border: 1px solid rgba(24, 31, 56, 0.15); 
    z-index: 9999; 
    border-radius: 5px; 
    margin-bottom: 30px;
    cursor: pointer;
    position: relative; 
    &::after {
        content: '';
        position: absolute;
        background-image: url(${arrow});
        width: 11px; 
        height: 8px; 
        background-repeat: no-repeat;
        background-size: contain; 
        top: calc(50% - 6px);
        right: 22px; 
        transform: rotate(180deg);
        pointer-events: none;
        transition: .3s ease;

    }
    &.is-open {
        .Dropdown-placeholder {
            opacity: 0.6; 
            transition: .3s ease;
        }
    }
    .Dropdown-placeholder, .Dropdown-option {
        padding: 10px 20px; 
        display: flex;
        align-items: center;
        font-size: 14px; 
        font-weight: 400; 
        color: ${props => props.theme.colors.faceliftBlue}; 
        transition: .3s ease;
    }
    .Dropdown-menu {
        position: absolute; 
        top: 50px; 
        background-color: white; 
        transition: .5s ease;
        width: 340px; 
    border: 1px solid rgba(24, 31, 56, 0.15); 
    border-radius: 5px; 
        box-shadow: 0px 3px 6px rgba(24, 31, 56, 0.15);

    .Dropdown-option {
        border-bottom: 1px solid ${props => props.theme.colors.mgrey};
        transition: .5s ease; 

        &:hover {
            background-color: ${props => props.theme.colors.lightGray}; 
            transition: .5s ease; 
        }
        &:last-of-type {
            border-bottom: none; 
        }
    }
    }
}
form {
    margin-bottom: 40px;
}
`

export const InviteCandidateFormContainer = styled.div`
width: 70%;
max-width: 700px; 
`